import PropTypes from "prop-types";
import { useState } from "react";
import Influencer from "../../../domain/influencer";
import { validateEmail } from "../../../util";
import { SuccessCheckIcon } from "./Icons.jsx";
import s from "./ShopEmpty.module.css";
import { Button } from "../../../themeV2";

export default function SubscribeForm({ influencerId }) {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    if (success || loading) return;

    if (!validateEmail(email)) {
      setError("Please enter a valid email address");
      return;
    }
    if (email.endsWith(".con")) {
      setError("Check your email — did you mean .com?");
      return;
    }

    setLoading(true);
    try {
      await Influencer.subscribeNewsletter({
        influencerId,
        email: email.trim(),
      });
      setSuccess(true);
    } catch {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className={s.subscribeSuccess} role="status">
        <SuccessCheckIcon className={s.subscribeSuccessIcon} />
        <span>Subscribed! We&apos;ll let you know when new items drop.</span>
      </div>
    );
  }

  return (
    <div className={s.subscribe}>
      <label htmlFor="shop-empty-email" className={s.subscribeLabel}>
        Get notified when new products are available
      </label>
      <div className={s.subscribeRow}>
        <input
          id="shop-empty-email"
          className={s.subscribeInput}
          type="email"
          autoComplete="email"
          placeholder="Enter your email address..."
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setError("");
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleSubmit(e);
            }
          }}
          aria-invalid={Boolean(error)}
        />
        <Button
          size="sm"
          disabled={!email.trim()}
          loading={loading}
          onClick={handleSubmit}
        >
          Subscribe
        </Button>
      </div>
      {error && (
        <p className={s.subscribeError} role="alert">
          {error}
        </p>
      )}
    </div>
  );
}

SubscribeForm.propTypes = {
  influencerId: PropTypes.number.isRequired,
};
